module.exports = __webpack_public_path__ + "static/media/twitter.2e4e7207.svg";